import { createSlice } from "@reduxjs/toolkit";
import { MAX_LATEST_EFFICE_BATCH_SIZE } from "constants/constants";
import { getEarlierSubs } from "./efficeTreeSlice";
import {
  hideSpaceBox,
  selectSpaceBoxActive,
  showSpaceBox,
} from "./spaceMediaSlice";
import { selectInThisSpace } from "./sharedSelectors";
let getState = null;
let dispatch = null;
import("Store").then((module) => {
  getState = module.store.getState;
  dispatch = module.store.dispatch;
});
const INITIAL_STATE = {
  infoPage: false,
  addPeopleModal: false,
  roomLinkModal: false,
  confirmationModal: null,
  loadingTextEffices: false,
};
export const slice = createSlice({
  name: "text",
  initialState: INITIAL_STATE,
  reducers: {
    setInfoPage: (state, action) => {
      state.infoPage = action.payload;
      if (!action.payload) state.addPeopleModal = false;
    },
    setAddPeopleModal: (state, action) => {
      state.addPeopleModal = action.payload;
    },
    setRoomLinkModal: (state, action) => {
      state.roomLinkModal = action.payload;
    },
    setConfirmationModal: (state, action) => {
      state.confirmationModal = action.payload;
    },
    setLoadingTextEffices: (state, action) => {
      state.loadingTextEffices = action.payload;
    },
    resetTextSlice: () => INITIAL_STATE,
  },
});

export const {
  setInfoPage,
  setAddPeopleModal,
  setRoomLinkModal,
  setConfirmationModal,
  setLoadingTextEffices,
  resetTextSlice,
} = slice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectInfoPage = (state) => state.text.infoPage;
export const selectAddPeopleModal = (state) => state.text.addPeopleModal;
export const selectRoomLinkModal = (state) => state.text.roomLinkModal;
export const selectConfirmationModal = (state) => state.text.confirmationModal;
export const selectLoadingTextEffices = (state) =>
  state.text.loadingTextEffices;

const scrollHeightBuffer = 600;
const scrollTimeBuffer = 30; // + 6000;
let scrollRef = null;
let scrollListener = null;
let resizeListener = null;
let timeOut = false;
let scrollTimer = null;
let reachingEnd = false;
let noMoreSubs = false;

export const startScrollListeners = (newScrollRef) => {
  scrollRef = newScrollRef;
  if (!scrollListener) scrollRef.addEventListener("scroll", handleScroll);
  if (!resizeListener) window.addEventListener("resize", handleScroll);
};

export const stopScrollListeners = () => {
  if (!scrollListener) scrollRef.removeEventListener("scroll", handleScroll);
  if (!resizeListener) window.removeEventListener("resize", handleScroll);
  scrollRef = null;
  clearTimeout(scrollTimer);
};

export const reassessScrollSubs = () => {
  handleScroll();
};

const handleScroll = () => {
  if (!timeOut && scrollRef) {
    timeOut = true;
    scrollTimer = setTimeout(() => {
      if (
        scrollRef.scrollHeight - Math.abs(scrollRef.scrollTop) <
        scrollRef.clientHeight + scrollHeightBuffer
      ) {
        if (!reachingEnd) {
          reachingEnd = true;
          checkForMore();
        }
      } else {
        if (reachingEnd) reachingEnd = false;
      }
      //setPosition(Math.abs(scrollRef.scrollTop));
      timeOut = false;
    }, scrollTimeBuffer);
  }
};

const checkForMore = () => {
  if (noMoreSubs) return;
  dispatch(getEarlierSubs())
    .then((length) => {
      if (length < MAX_LATEST_EFFICE_BATCH_SIZE) noMoreSubs = true;
      reachingEnd = false;
    })
    .catch(() => {
      window.log("Failed to Get More Subs");
    });
};

export const resetScrollService = () => {
  noMoreSubs = false;
  timeOut = false;
  reachingEnd = false;
  if (scrollRef) scrollRef.scrollTop = 0;
};

export const toggleInfoPage = () => {
  if (selectInfoPage(getState())) closeInfoPage();
  else openInfoPage();
};

export const openInfoPage = () => {
  dispatch(setInfoPage(true));
  if (selectSpaceBoxActive(getState())) hideSpaceBox();
};
export const closeInfoPage = () => {
  if (selectInThisSpace(getState())) showSpaceBox();
  dispatch(setInfoPage(false));
};

export default slice.reducer;
